var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.material.pc_jb_img)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.img_url + _vm.material.pc_jb_img),expression:"img_url + material.pc_jb_img"}],staticClass:"report_xfc",on:{"click":_vm.sup_tc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }